export const voiceCalls = {
  "head": {
    "title": "Appels",
    "subtitle": "Les appels auxquels votre standard téléphonique a répondu."
  },
  "stats": {
    "all": "appel | appels",
    "spoken": "décroché | décrochés",
    "inTotal": "au total"
  },
  "toolbar": {
    "searchLabel": "Rechercher",
    "searchPlaceholder": "Numéro de l'appelant…",
    "clear": "Effacer la recherche",
    "showLabel": "Afficher",
    "showAll": "Tous les appels",
    "showSpoken": "Seulement décrochés",
    "showRecorded": "Seulement enregistrés"
  },
  "notice": {
    "noRecording": "Les appels ne sont pas enregistrés.",
    "noRecordingHow": "Activez « Enregistrer les appels » dans les réglages de votre standard téléphonique : vous pourrez alors les écouter et les transcrire ici."
  },
  "empty": {
    "title": "Personne ne vous a encore appelé",
    "text": "Quand quelqu'un appellera votre numéro, l'appel apparaîtra ici avec qui a appelé, la durée et ce qu'il voulait.",
    "filteredTitle": "Aucun appel avec ce filtre",
    "filteredText": "Essayez d'enlever la recherche ou les filtres ci-dessus."
  },
  "item": {
    "notSpoken": "Sans échange",
    "unknownCaller": "Numéro masqué",
    "linkSent": "Lien de réservation envoyé",
    "play": "Écouter l'enregistrement",
    "pause": "Pause",
    "showTranscript": "Voir la transcription",
    "hideTranscript": "Masquer la transcription",
    "transcribe": "Transcrire et résumer",
    "transcribing": "Transcription…",
    "noRecordingShort": "Cet appel n'a pas été enregistré",
    "viewReservation": "Voir la réservation",
    "noSummary": "Cet appel n'a pas de résumé.",
    "copy": "Copier le numéro",
    "copied": "Copié"
  },
  "errors": {
    "load": "Impossible de charger les appels.",
    "play": "Impossible de lire l'enregistrement.",
    "transcribe": "Impossible de demander la transcription."
  },
  "table": {
    "call": "Appel",
    "reservation": "Réservation",
    "listing": "Logement",
    "summary": "Résumé",
    "duration": "Durée",
    "date": "Date"
  }
};
